import React from 'react';

const DonatePage = ({ language }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-100 to-green-100 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-green-800 mb-4">
              {language === 'en' ? '🙏 Support Our Mission' : '🙏 எங்கள் பணியை ஆதரியுங்கள்'}
            </h1>
            <p className="text-lg text-gray-700">
              {language === 'en'
                ? 'Your generous donation helps us provide free religious services to the community'
                : 'உங்கள் தாராள நன்கொடை சமூகத்திற்கு இலவச ஆன்மீக ஸேவைகளை வழங்க எங்களுக்கு உதவுகிறது'}
            </p>
          </div>

          {/* UPI/BHIM Payment Option */}
          <div className="mt-4 pt-4">
            <h3 className="text-2xl font-bold text-center text-green-800 mb-6">
              {language === 'en' ? '💳 Donate via UPI/BHIM' : '💳 UPI/BHIM மூலம் நன்கொடை அளிக்கவும்'}
            </h3>
            <div className="bg-gradient-to-br from-orange-50 to-green-50 rounded-xl p-6 text-center shadow-inner">
              <img 
                src="/bhim-qr.jpg" 
                alt="UPI QR Code" 
                className="mx-auto max-w-xs w-full rounded-lg shadow-lg mb-4"
              />
              <p className="text-lg font-semibold text-gray-800 mb-2">
                {language === 'en' ? 'Scan QR Code with any UPI App' : 'எந்த UPI செயலி மூலமும் QR குறியீட்டை ஸ்கேன் செய்யவும்'}
              </p>
              <p className="text-gray-600 mb-4">
                {language === 'en' ? 'PhonePe • Google Pay • Paytm • BHIM' : 'PhonePe • Google Pay • Paytm • BHIM'}
              </p>
              <div className="bg-white rounded-lg p-4 inline-block shadow-sm">
                <p className="text-sm text-gray-600 mb-1">
                  {language === 'en' ? 'UPI ID / VPA:' : 'UPI ID / VPA:'}
                </p>
                <p className="text-xl font-mono font-bold text-green-700">svknvs@okicici</p>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center text-sm text-gray-600">
            <p>{language === 'en' ? 'Secure donations powered by UPI' : 'UPI மூலம் பாதுகாப்பான நன்கொடைகள்'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonatePage;